module.exports = __webpack_public_path__ + "img/ina-hrs.235749f4.png";